import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { Subscription } from "rxjs";
import { LanguageService } from "../../services/language.service";

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrl: './reviews.component.scss',
  animations: [
    trigger('fadeAnimation', [
      transition('* => *', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class ReviewsComponent implements OnInit, OnDestroy {
  private _languageService : LanguageService = inject(LanguageService);

  @Input() giPantMode: boolean = false;
  @Input() henterPantMode: boolean = false;

  configCarouselData: {[key: string]: CarouselItem[]} = {
    giPant: [
      {
        active: true,
        image: '../../assets/images/reviews/about-gp.png',
        imageEng: '../../assets/images/reviews/about-gp-eng.png',
        team: {
          logo: '../../assets/images/reviews/team-logo.png',
          name: 'Motvind IL',
          club: '3.divisjon HESA'
        },
        // review: 'Reviews coming soon' // TODO
        review: 'Anmeldelser kommer snart'
      }
      // {
      //   active: false,
      //   image: '../../assets/images/reviews/team-2.jpg',
      //   team: {
      //     logo: '../../assets/images/logos/grand-logo.png',
      //     name: 'Another Team Name',
      //     club: '1 Division'
      //   },
      //   review: 'Another amazing team story with their donations!'
      // },
      // {
      //   active: false,
      //   image: '../../assets/images/reviews/team-3.jpg',
      //   team: {
      //     logo: '../../assets/images/logos/grand-logo.png',
      //     name: 'Another Team',
      //     club: '3 Division'
      //   },
      //   review: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi commodi distinctio eius vitae! Error eum impedit incidunt obcaecati omnis. Quia!'
      // },
      // {
      //   active: false,
      //   image: '../../assets/images/reviews/team-4.jpg',
      //   team: {
      //     logo: '../../assets/images/logos/grand-logo.png',
      //     name: 'Team Name',
      //     club: '4 Division'
      //   },
      //   review: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem illo nostrum praesentium quo similique, soluta.'
      // }
    ],
    henterPant: [
      {
        active: true,
        image: '../../assets/images/reviews/about-hp.png',
        imageEng: '../../assets/images/reviews/about-hp-eng.png',
        team: {
          logo: '../../assets/images/reviews/team-logo.png',
          name: 'Motvind IL',
          club: '3.divisjon HESA'
        },
        // review: 'Reviews coming soon' // TODO
        review: 'Anmeldelser kommer snart'
      }
      // {
      //   active: false,
      //   image: '../../assets/images/reviews/team-4.jpg',
      //   team: {
      //     logo: '../../assets/images/logos/grand-logo.png',
      //     name: 'Henter Pant Team',
      //     club: 'Sustainability Heroes'
      //   },
      //   review: 'Henter Pant made a real change in their community.'
      // },
      // {
      //   active: false,
      //   image: '../../assets/images/reviews/team-2.jpg',
      //   team: {
      //     logo: '../../assets/images/logos/grand-logo.png',
      //     name: 'Henter Pant Team',
      //     club: 'Sustainability Heroes'
      //   },
      //   review: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Esse libero, porro?'
      // },
      // {
      //   active: false,
      //   image: '../../assets/images/reviews/team-1.png',
      //   team: {
      //     logo: '../../assets/images/logos/grand-logo.png',
      //     name: 'Henter Pant Team',
      //     club: 'Sustainability Heroes'
      //   },
      //   review: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto eligendi laudantium recusandae ut?'
      // }
    ]
  };

  activeItems: CarouselItem[] = [];
  currentIndex: number = 0;
  langSubscription!: Subscription;
  currentLang!: string;

  get activeItem(): CarouselItem | undefined {
    return this.activeItems[this.currentIndex];
  }

  ngOnInit(): void {
    if (this.giPantMode) this.activeItems = this.configCarouselData['giPant'] || [];
    if (this.henterPantMode) this.activeItems = this.configCarouselData['henterPant'] || [];

    this.currentLang = this._languageService.currentLang;
    this.languageSubscription();
  }

  languageSubscription(): void {
    this.langSubscription = this._languageService.onLangChange$.subscribe((event: any) => {
      this.currentLang = this._languageService.currentLang;
    });
  }

  next(): void {
    if (this.activeItems.length > 0) {
      this.currentIndex = (this.currentIndex + 1) % this.activeItems.length;
    }
  }

  prev(): void {
    if (this.activeItems.length > 0) {
      this.currentIndex = (this.currentIndex - 1 + this.activeItems.length) % this.activeItems.length;
    }
  }

  goToSlide(index: number): void {
    if (index >= 0 && index < this.activeItems.length) {
      this.currentIndex = index;
    }
  }

  ngOnDestroy(): void {
    if (this.langSubscription) this.langSubscription.unsubscribe();
  }
}

interface CarouselItem {
  active: boolean;
  image: string;
  imageEng?: string;
  team: {
    logo: string;
    name: string;
    club: string;
  };
  review: string;
}
